<div class="dt-bootstrap"   [ngClass]= '{"instore-background":!this.isBuyNow , "buyNow": this.isBuyNow, "appModal": apiDomain}'>
<dt-an-prequalification-lib></dt-an-prequalification-lib>
</div>
